import React from "react";
import "./HTML_MAIN_CSS.css";

const HTMLOrderedLists = () => {
  return (
    <div className="html-container">
      <h1>HTML Lists – Ordered Lists</h1>

      {/* 1. Introduction */}
      <section id="introduction">
        <h2>1. Introduction</h2>
        <p>
          Ordered lists in HTML are used to display items in a specific sequence. They are created using the <code>&lt;ol&gt;</code> element, with each item inside a <code>&lt;li&gt;</code> element.
        </p>
      </section>

      {/* 2. Basic Ordered List */}
      <section id="basic-ol">
        <h2>2. Basic Ordered List</h2>
        <p>Example:</p>
        <pre>
          <code>{`<ol>
  <li>First item</li>
  <li>Second item</li>
  <li>Third item</li>
</ol>`}</code>
        </pre>
      </section>

      {/* 3. Types of Ordered Lists */}
      <section id="ol-types">
        <h2>3. Types of Ordered Lists</h2>
        <p>HTML supports several numbering types using the <code>type</code> attribute:</p>

        <ul>
          <li><strong>Decimal (default)</strong> - 1, 2, 3 … <br />
            <code>&lt;ol type="1"&gt; ... &lt;/ol&gt;</code>
          </li>
          <li><strong>Uppercase letters</strong> - A, B, C … <br />
            <code>&lt;ol type="A"&gt; ... &lt;/ol&gt;</code>
          </li>
          <li><strong>Lowercase letters</strong> - a, b, c … <br />
            <code>&lt;ol type="a"&gt; ... &lt;/ol&gt;</code>
          </li>
          <li><strong>Uppercase Roman numerals</strong> - I, II, III … <br />
            <code>&lt;ol type="I"&gt; ... &lt;/ol&gt;</code>
          </li>
          <li><strong>Lowercase Roman numerals</strong> - i, ii, iii … <br />
            <code>&lt;ol type="i"&gt; ... &lt;/ol&gt;</code>
          </li>
        </ul>
      </section>

      {/* 4. Starting Number */}
      <section id="start-number">
        <h2>4. Starting Number</h2>
        <p>You can start an ordered list at a specific number using the <code>start</code> attribute:</p>
        <pre>
          <code>{`<ol start="5">
  <li>Item 5</li>
  <li>Item 6</li>
</ol>`}</code>
        </pre>
      </section>

      {/* 5. Nested Ordered Lists */}
      <section id="nested-ol">
        <h2>5. Nested Ordered Lists</h2>
        <p>Ordered lists can be nested to create sublists:</p>
        <pre>
          <code>{`<ol>
  <li>Fruits
    <ol type="a">
      <li>Apple</li>
      <li>Banana</li>
    </ol>
  </li>
  <li>Vegetables
    <ol type="i">
      <li>Carrot</li>
      <li>Spinach</li>
    </ol>
  </li>
</ol>`}</code>
        </pre>
      </section>

      {/* 6. Styling Ordered Lists */}
      <section id="ol-styling">
        <h2>6. Styling Ordered Lists</h2>
        <p>You can style ordered lists with CSS:</p>
        <pre>
          <code>{`.html-container ol {
  padding-left: 20px;
  margin-bottom: 20px;
  color: #007bff;
  font-weight: bold;
}

.html-container ol li {
  margin-bottom: 5px;
}`}</code>
        </pre>
      </section>

      {/* 7. Best Practices */}
      <section id="best-practices">
        <h2>7. Best Practices</h2>
        <ul>
          <li>Use <code>&lt;ol&gt;</code> when order matters (steps, ranking, priorities).</li>
          <li>Use nested lists sparingly to maintain readability.</li>
          <li>Use CSS for styling instead of inline attributes for maintainability.</li>
          <li>Provide descriptive list items for accessibility.</li>
        </ul>
      </section>

      {/* 8. Summary */}
      <section id="summary">
        <h2>8. Summary</h2>
        <ul>
          <li>Ordered lists display items sequentially using numbers, letters, or Roman numerals.</li>
          <li>The <code>type</code> and <code>start</code> attributes customize numbering style and starting point.</li>
          <li>Nested lists help create subcategories, but keep them simple.</li>
          <li>Use CSS to style lists and improve readability and accessibility.</li>
        </ul>
      </section>
    </div>
  );
};

export default HTMLOrderedLists;
